import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";

import { MarketingNotificationsFormGroup } from "./marketing-notifications.model";

@Component({
	selector: "obg-m-marketing-notifications",
	templateUrl: "./marketing-notifications.component.html",
	styleUrls: ["./marketing-notifications.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MarketingNotificationsComponent {
	@HostBinding("class.obg-m-marketing-notifications") hostCssClass = true;

	@Input() formGroup: MarketingNotificationsFormGroup | undefined;

	@Output() change = new EventEmitter<string>();
}
